var ScrollBar = {
	bars:{},

	update: function(div) {
		if (Events.pointer.down == "touchstart") return;
		if (!ScrollBar.bars.hasOwnProperty(div)) {
			$(div).niceScroll({cursorborder:"0px"});
			ScrollBar.bars[div] = true;
		} else {
			$(div).getNiceScroll().resize();
		}

	}
}